export default __webpack_public_path__ + "img/Google-Logo-660x330.b750f60b.png";